<script setup>
import { ref, watch } from 'vue'
import { useMouseInElement } from '@vueuse/core'

// props适配图片列表

const props = defineProps(['imageList','checkIMG'])
const emits=defineEmits('ClearCheckIMG')

// 图片列表
// const imageList = [
//     "https://yanxuan-item.nosdn.127.net/d917c92e663c5ed0bb577c7ded73e4ec.png",
//     "https://yanxuan-item.nosdn.127.net/e801b9572f0b0c02a52952b01adab967.jpg",
//     "https://yanxuan-item.nosdn.127.net/b52c447ad472d51adbdde1a83f550ac2.jpg",
//     "https://yanxuan-item.nosdn.127.net/f93243224dc37674dfca5874fe089c60.jpg",
//     "https://yanxuan-item.nosdn.127.net/f881cfe7de9a576aaeea6ee0d1d24823.jpg"
// ]

// 1.小图切换大图显示
const activeIndex = ref(0)

console.log('props.checkIMG---',props.checkIMG)

// 2. 获取鼠标相对位置
const target = ref(null)
const { elementX, elementY, isOutside } = useMouseInElement(target)

// 3. 控制滑块跟随鼠标移动（监听elementX/Y变化，一旦变化 重新设置left/top）
const left = ref(0)
const top = ref(0)

const positionX = ref(0)
const positionY = ref(0)
watch([elementX, elementY, isOutside], () => {
    // console.log('xy变化了');
    // 如果鼠标没有移入到盒子里面 直接不执行后面的逻辑
    if (isOutside.value) return
    // console.log('后续逻辑执行了');
    // 有效范围内控制滑块距离
    // 横向
    if (elementX.value > 100 && elementX.value < 300) {
        left.value = elementX.value - 100
    }
    // 纵向
    if (elementY.value > 100 && elementY.value < 300) {
        top.value = elementY.value - 100
    }

    // 处理边界
    if (elementX.value > 300) { left.value = 200 }
    if (elementX.value < 100) { left.value = 0 }

    if (elementY.value > 300) { top.value = 200 }
    if (elementY.value < 100) { top.value = 0 }

    // 控制大图的显示
    positionX.value = -left.value * 2
    positionY.value = -top.value * 2

})

const startIndex = ref(0); // 当前起始索引
const visibleCount = 5; // 每次显示的图片数量

// 计算当前可见的图片列表
const visibleImages = computed(() =>
    props.imageList.slice(startIndex.value, startIndex.value + visibleCount)
);

// 是否禁用左按钮
const isPrevDisabled = computed(() => startIndex.value === 0);

// 是否禁用右按钮
const isNextDisabled = computed(
    () => startIndex.value + visibleCount >= props.imageList.length
);

// 点击左按钮
const handlePrev = () => {
    if (startIndex.value > 0) {
        startIndex.value--;
    }
};

// 点击右按钮
const handleNext = () => {
    if (startIndex.value + visibleCount < props.imageList.length) {
        startIndex.value++;
    }
};

// 鼠标悬浮切换激活图片
const handleMouseEnter = (index) => {
    // console.log(index)
    activeIndex.value = index;
    emits('ClearCheckIMG')
};
const isMobile = ref(false);//false代表pc
onMounted(() => {
  isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);



})
</script>


<template>
     <div style="display: flex;">
    <!-- {{ elementX }}, {{ elementY }}, {{ isOutside }} -->
   
        <!-- 小图列表 -->
        <div class="image-list-container">
            <!-- 左按钮 -->
            <button class="btn prev" @click="handlePrev" :disabled="isPrevDisabled">
                &lt;
            </button>

            <ul class="small">
                <li v-for="(img, i) in visibleImages" :key="i" :class="{ active: i === activeIndex }"
                    @mouseenter="handleMouseEnter(i)">
                   
                    <img :src="img" alt="缩略图" />
                </li>
            </ul>
            <!-- 右按钮 -->
            <button class="btn next" @click="handleNext" :disabled="isNextDisabled">
                &gt;
            </button>
        </div>
        <div class="goods-image">
        <!-- 左侧大图-->
        <div class="middle" ref="target">
            <img :src="props.checkIMG!=undefined ? props.checkIMG:visibleImages[activeIndex]" alt="" />
            <!-- 蒙层小滑块 -->
            <div class="layer" v-show="!isOutside" :style="{ left: `${left}px`, top: `${top}px` }"></div>
        </div>
        
        <!-- 放大镜大图 -->
        <div class="large" v-show="!isOutside&&isMobile == false">
        <div style="position: relative;width: 480px;height: 480px;overflow: hidden;">
            <img :src="imageList[activeIndex]" alt="" :style="[{position: 'absolute',left: `${positionX}px`,top:`${positionY}px`,width:'880px',height:'880px',maxWidth:'200%',maxHeight:'200%',objectFit:'contain'}]"/>
        </div>  
    </div>
    </div>
</div>
</template>

<style scoped lang="scss">
img {
    width: 100%;
    /* 或者指定宽度 */
    height: auto;
    /* 高度自动，保持原始比例 */
    object-fit: contain;
}
.image-list-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 10px;
        margin-right: 20px;
    }

    .small {
        width: 70px;
       
        display: flex;
        list-style: none;
        gap: 10px;
        overflow: hidden;
        // width: 400px;
        flex-direction: column;
    }

    .small li {
        width: 70px;
        height: 70px;
        border: 1px solid transparent;
        cursor: pointer;
        border-radius: 6px;
// border: 1px solid #FC3938;
    }

    .small li img {
        width: 70px;
        height: 70px;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
    }

    .small li.active {
        border-color: #FC3938;
    }

    .btn {
        width: 30px;
        height: 30px;
        background: #f0f0f0;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

.goods-image {
    width: 480px;
    height: 480px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;

    .middle {
        width: 480px;
    height: 480px;
    background: #F5F6F8;
    border-radius: 8px;v

        img {
            width: 100%;
            border-radius: 8px;
        }
    }

    .large {
        position: absolute;
    top: 0;
    left: 480px;
    width: 480px;
    height: 480px;
    z-index: 500;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    // background-repeat: no-repeat;
    // // 背景图:盒子的大小 = 2:1  将来控制背景图的移动来实现放大的效果查看 background-position
    // background-size: 800px 800px;
    background-color: #f8f8f8;
    }

    .layer {
        width: 280px;
        height: 280px;
        background: rgba(0, 0, 0, 0.2);
        // 绝对定位 然后跟随咱们鼠标控制left和top属性就可以让滑块移动起来
        left: 0;
        top: 0;
        position: absolute;
    }

   
    // .small {
    //     width: 80px;

    //     img {
    //         width: 100%;
    //     }

    //     li {
    //         width: 68px;
    //         height: 68px;
    //         margin-left: 12px;
    //         margin-bottom: 15px;
    //         cursor: pointer;

    //         &:hover,
    //         &.active {
    //             border: 2px solid $xtxColor;
    //         }
    //     }
    // }
}
/* 响应式设计 */
@media (max-width: 768px) {
    img {
    width: 100%;
    /* 或者指定宽度 */
    height: auto;
    /* 高度自动，保持原始比例 */
    object-fit: contain;
}
.image-list-container {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0px;
    }

    .small {
        display: flex;
        list-style: none;
        gap: 2px;
        overflow: hidden;
        width: 100%;
    }

    .small li {
        width: 68px;
        height: 68px;
        border: 2px solid transparent;
        cursor: pointer;
    }

    .small li img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .small li.active {
        border-color: #007bff;
    }

    .btn {
        width: 30px;
        height: 30px;
        background: #f0f0f0;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

.goods-image {
    width: 100%;
    height: auto;
    position: relative;
    display: flex;
    flex-direction: column;

    .middle {
        width: 100%;
      height: auto;
      background: #f5f5f5;

        img {
            width: 100%;
            // padding: 0 20px;
            background: #ffffff;
        }
    }

    .large {
        position: absolute;
      top: 0;
      left: 412px;
      width: 400px;
      height: 400px;
      z-index: 500;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      background-repeat: no-repeat;
      // 背景图:盒子的大小 = 2:1  将来控制背景图的移动来实现放大的效果查看 background-position
      background-size: 800px 800px;
      background-color: #f8f8f8;
    }

    .layer {
        width: 200px;
      height: 200px;
      background: rgba(0, 0, 0, 0.2);
      // 绝对定位 然后跟随咱们鼠标控制left和top属性就可以让滑块移动起来
      left: 0;
      top: 0;
      position: absolute;
    }

  
    // .small {
    //     width: 80px;

    //     img {
    //         width: 100%;
    //     }

    //     li {
    //         width: 68px;
    //         height: 68px;
    //         margin-left: 12px;
    //         margin-bottom: 15px;
    //         cursor: pointer;

    //         &:hover,
    //         &.active {
    //             border: 2px solid $xtxColor;
    //         }
    //     }
    // }
}
}
</style>